import { render } from "./HomeBannerNews.vue?vue&type=template&id=6664b9b2&scoped=true"
import script from "./HomeBannerNews.vue?vue&type=script&lang=js"
export * from "./HomeBannerNews.vue?vue&type=script&lang=js"

import "./HomeBannerNews.vue?vue&type=style&index=0&id=6664b9b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6664b9b2"]])

export default __exports__